/**
 * Formatting shared by the history modal's three tabs (campaigns,
 * challenges, rewards).
 *
 * Dates are shown in Tehran time: server timestamps are UTC and cycle keys
 * are Tehran calendar dates, so formatting in the browser's own zone put a
 * day boundary in the wrong place for users outside Iran.
 */
import { TEHRAN_TIME_ZONE } from './labels';

/** Scrolls the history modal's list back to its top (see CampaignHistory). */
export const scrollHistoryToTop = (target: EventTarget | null) => {
  if (target instanceof Element) {
    target.closest('[data-history-scroll]')?.scrollTo({ top: 0 });
  }
};

/** "۱۴۰۴/۰۲/۱۲" in the Persian calendar, or a dash. */
export const shamsiNumericDate = (date: Date | null): string => {
  if (!date || Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('fa-IR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: TEHRAN_TIME_ZONE
  }).format(date);
};

/** "۲۴ دی ماه ۱۴۰۴", as in the design, or a dash. */
export const shamsiLongDate = (iso?: string | null): string => {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  const parts = new Intl.DateTimeFormat('fa-IR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: TEHRAN_TIME_ZONE
  }).formatToParts(date);
  const part = (type: string) =>
    parts.find((item) => item.type === type)?.value ?? '';
  return `${part('day')} ${part('month')} ماه ${part('year')}`;
};

/** How far back the history goes when the feed was cut off. */
export const TRUNCATED_NOTE = 'فقط موارد اخیر نمایش داده می‌شود.';
